<template>
  <div class="rel">
    <!-- <v-btn class="absolute-close" depressed dark large color="spiceRed" @click="closeModal">
      <v-icon>close</v-icon>
    </v-btn>-->
    <v-card flat class="transparent">
      <v-card-text class="inner-content mt-2">
        <v-layout row wrap>
          <v-flex md7 xs12>
            <h1 class="title pb-3">
              Travel
              <span>Services</span>
            </h1>
            <h2>Gamut of travel services under one roof</h2>
            <p>Spice Money provides opportunity to book railway/flight/bus tickets and low cost hotels under one roof.</p>
            <p>In today’s fast paced world no one has the time to stand in colossal queues for booking tickets. Our travel services fulfill the travel needs of millions of travelers looking for reasonable, reliable, close to home and comprehensive travel solutions.</p>
            <p>We offer an all-inclusive travel experience, so look no further and enjoy a gamut of services at one place.</p>
            <p>The travel solutions we provide include</p>
          </v-flex>
          <v-flex md5 xs12 class="text-xs-center pl-5" v-if="this.$vuetify.breakpoint.lgAndUp">
            <img :src="require('@/assets/images/travel.jpg')" alt="spice money" width="100%">
          </v-flex>

          <v-flex xs12 pt-3>
            <ul class="icon-triggers">
              <li
                :class="irctc?'active':''"
                @click="irctc=true;flights=false;bus=false;hotel=false"
              >IRCTC
                <!-- <svg style="width:100%;height:100%" viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M12,2C8,2 4,2.5 4,6V15.5A3.5,3.5 0 0,0 7.5,19L6,20.5V21H8.23L10.23,19H14L16,21H18V20.5L16.5,19A3.5,3.5 0 0,0 20,15.5V6C20,2.5 16.42,2 12,2M7.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 9,15.5A1.5,1.5 0 0,1 7.5,17M11,10H6V6H11V10M13,10V6H18V10H13M16.5,17A1.5,1.5 0 0,1 15,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 16.5,17Z"
                  ></path>
                </svg>-->
              </li>

              <li
                :class="flights?'active':''"
                @click="irctc=false;flights=true;bus=false;hotel=false"
              >Flights Booking
                <!-- <svg style="width:100%;height:100%" viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M21,16V14L13,9V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V9L2,14V16L10,13.5V19L8,20.5V22L11.5,21L15,22V20.5L13,19V13.5L21,16Z"
                  ></path>
                </svg>-->
              </li>
              <li
                :class="bus?'active':''"
                @click="irctc=false;flights=false;bus=true;hotel=false"
              >Bus Ticketing
                <!-- <svg style="width:100%;height:100%" viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M3,6C1.89,6 1,6.89 1,8V15H3A3,3 0 0,0 6,18A3,3 0 0,0 9,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V8C23,6.89 22.11,6 21,6H3M2.5,7.5H6.5V10H2.5V7.5M8,7.5H12V10H8V7.5M13.5,7.5H17.5V10H13.5V7.5M19,7.5H21.5V13L19,11V7.5M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z"
                  ></path>
                </svg>-->
              </li>
              <li
                :class="hotel?'active':''"
                @click="irctc=false;flights=false; bus=false;hotel=true"
              >Hotel Booking
                <!-- <svg style="width:100%;height:100%" viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M19,7H11V14H3V5H1V20H3V17H21V20H23V11A4,4 0 0,0 19,7M7,13A3,3 0 0,0 10,10A3,3 0 0,0 7,7A3,3 0 0,0 4,10A3,3 0 0,0 7,13Z"
                  ></path>
                </svg>-->
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="irctc">
            <v-flex xs12>
              <h2>Train Tickets</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>We provide the agents the medium to book train tickets and become IRCTC authorized train ticketing agency and earn an instant commission on sale of every ticket and avail monthly incentive plans. We are the only company to offer commission on rail tickets. We provide a user friendly and quick interface to our agents to book tickets for their customers through a single wallet system. The wallet can be recharged by using multiple options like Credit Card, Debit Card, Cash, Cheque, DD and Net Banking.</p>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="flights">
            <v-flex xs12>
              <h2>Flight Tickets</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>We provide Domestic and International Flights ticketing solutions with all available combinations and airlines. The service provides the best routing options with an easy to book interface. There is also a presence of dedicated customer care only for airlines related queries and enquiries. This is a complete Travel Management Solution on Single Interface. The agent can instantly book and confirm the tickets and earn attractive margins and commissions.</p>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="bus">
            <v-flex xs12>
              <h2>Bus Tickets</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>There are times when there is an unavailability of train tickets. In those instances, our bus ticketing solutions are the best alternative for our customers. To provide this service, we have a tie up with around 700 tour and travel operators. We provide an interface through which we enable search and booking of tickets online. The agent can instantly book and confirm tickets by using this interface and earn attractive margins on every ticket booked.</p>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="hotel">
            <v-flex xs12>
              <h2>Hotel Bookings</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>We have a huge database of hotels across cities and the length and breadth of India. We cater to every budget and star category and are available for instant booking and confirmation on a single interface. The USP of this service is that we guaranteed room availability at highly discounted prices which are a great value to our customers.</p>
              <p>The agent can earn instant commissions on every room booked.</p>
            </v-flex>
          </v-layout>
        </transition>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.v-toolbar__title {
  color: #2a3997 !important;
}
.title {
  text-transform: uppercase;
  font-size: 64px !important;
  color: #000;
  font-weight: 100;
}
.title span {
  font-weight: 900;
}
h2 {
  font-size: 30px;
  padding-bottom: 15px;
}
p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 10px;
  color: #333;
}

.content-img {
  -webkit-box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
  box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
}
.logo-inner {
  align-items: center;
}
.nav-listing {
  list-style: none;
  display: flex;
  flex-direction: row;
}
.nav-listing li {
  margin-left: 10px;
}
.nav-listing li a {
  text-decoration: none;
  padding: 10px 15px;
  transition: all ease-in-out 0.2s;
  color: #475055;
  font-size: 16px;
}
.nav-listing li a:hover,
.nav-listing li a.active {
  color: #4385f3;
}
.icon-triggers {
  list-style: none;
  margin: 0;
  padding: 12px 0 0px 50px;
  background: #293896;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  min-width: 150px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  opacity: 0.7;
  border-bottom: solid 3px tranparent;
  margin-right: 15px;
}
.icon-triggers li.active,
.icon-triggers li:hover {
  opacity: 1;
  border-bottom: solid 3px orange;
}
/* .icon-triggers {
  list-style: none;
  margin: 0;
  padding: 30px 0 0 0;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: #ff7a00;
  border: 3px solid #ff7a00;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  line-height: 0;
  padding: 1.9em;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  width: 120px;
  height: 120px;
  margin-right: 8%;
  animation: categoryTriggerPulse 3s infinite;
}

.icon-triggers li:before,
.icon-triggers li:after {
  content: "";
  display: block;
  position: absolute;
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  opacity: 0;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.icon-triggers li:before {
  border: 2px solid #ff7a00;
}

.icon-triggers li.active,
.icon-triggers li:hover {
  background-color: rgb(255, 122, 0);
  color: #fff;

  animation: none;
}
.icon-triggers path {
  transition: all ease-in-out 0.6s;
}
.icon-triggers li path,
.icon-triggers li path {
  fill: rgb(255, 122, 0);
}

.icon-triggers li.active path,
.icon-triggers li:hover path {
  fill: #fff;
}

.icon-triggers li.active:hover {
  cursor: default;
}

.icon-triggers li:not(.active):hover:before {
  border-top-color: #ff7a00;
  border-right-color: #ff7a00;
  border-bottom-color: #ff7a00;
  -webkit-transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
  transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
}

.icon-triggers li:not(.active):hover:after {
  border-top: 3px solid #ff7a00;
  border-left-width: 2px;
  border-right-width: 2px;
  -webkit-transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  transform: rotate(540deg);
  -webkit-transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
}

.icon-triggers li:hover:after {
  opacity: 1;
}

@-webkit-keyframes categoryTriggerPulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgb(255, 122, 0, 0.8);
  }
  50% {
    -webkit-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

@keyframes categoryTriggerPulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
  }
  50% {
    -moz-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
} */

.standard-listing {
  color: #ff7a00;
}
.standard-listing li {
  float: left;
  width: 50%;
}
@media only screen and (max-width: 768px) {
  .inner-content {
    padding: 25px;
  }
  .title {
    font-size: 18px !important;
  }
}

.earn-now {
  position: relative;
  padding: 25px 30px;
  background: #2d2d2d;
  font-size: 30px;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.join-now {
  background: #ec1c25;
  padding: 0px 45px;
  height: 83px;
  line-height: 83px;
  text-transform: uppercase;
  color: #fff;
  display: inline-block;
  font-size: 30px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  text-decoration: none;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.52);
  z-index: 2;
  transition: all ease-in-out 0.3s;
}

.join-now:hover {
  border-radius: 5px;
  -webkit-box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
  box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
}

@media only screen and (max-width: 768px) {
  .earn-now {
    position: relative;
    padding: 15px 20px;
    font-size: 22px;
  }
  .join-now {
    padding: 0px 25px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin-top: 15px;
  }
  .icon-triggers li {
    width: 40px;
    height: 40px;
    padding: 5px;
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 14px;
  }
  .icon-triggers {
    padding-left: 10px;
  }
  .icon-triggers li {
    min-width: 140px;

    text-transform: capitalize;
    font-size: 14px;
  }
  .icon-triggers li:nth-child(1) {
    min-width: 70px;
  }
  .icon-triggers li:nth-child(2) {
    min-width: 110px;
  }
  .icon-triggers li:nth-child(3) {
    min-width: 110px;
  }
  .icon-triggers li:nth-child(4) {
    min-width: 110px;
  }
}
@media only screen and (max-width: 550px) {
  .icon-triggers {
    padding: 0;
  }
  .icon-triggers li {
    width: 100%;
    margin: 0;
    padding: 0;
    line-height: 40px;
  }
}
</style>

<script>
import TravelDetails from "./TravelDetails.ts";
export default TravelDetails;
</script>